import { styled } from '@mui/material/styles';
import Box from '@mui/material/Box';

export const StyledStack = styled(Box)({
  margin: '40px 0 0 -30px',
  display: 'grid',
  gridTemplateColumns: '30px 1fr',
  gridTemplateAreas: `
        "sort-column editor-column"
        "spacer2 error"
        "spacer3 edit-actions"`
});



// WEBPACK FOOTER //
// ./src/vp-ui/components/CampaignElementWrapper/styles.js